import { Box, Stack, Typography } from "@mui/material";
import React from "react";

import { terms_data } from "./data";

const TermsContent = () => {
  return (
    <Box
      sx={{
        py: 1,
        px: 2,
      }}
    >
      <Stack>
        <Typography variant="body2" sx={{ color: "#0A0B0A" }}>
          AGREEMENT
        </Typography>
        <Typography variant="h4" sx={{ color: "#0A0B0A", fontWeight: 700 }}>
          Terms and Conditions
        </Typography>
        <Typography variant="body2" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
          Last updated on 4/11/2024
        </Typography>
      </Stack>

      <Box sx={{ my: 2 }}>
        {terms_data?.map((term, index) => (
          <Stack key={index} sx={{ my: 2 }}>
            <Typography
              variant="body1"
              sx={{ color: "#494949", fontWeight: 700, mb: 2 }}
            >
              {term.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "#000000" }}>
              {term.text}
            </Typography>
          </Stack>
        ))}
      </Box>
    </Box>
  );
};

export default TermsContent;
